<div class="porfolio-properties-wrapper">
  <div *ngIf="showTitleInfo">
    <h2>{{'raci.portfolioProperties.argusTitle' | translate | uppercase}}</h2>
    <p>{{'raci.portfolioProperties.argusSubTitle' | translate}}</p>
  </div>
  <div class="porfolio-properties-body">
    <div class="porfolio-properties-project">
      <svg-icon src='./assets/icons/icon-by-region-default.svg'
                title="{{'raci.participantsAssignment.participants' | translate | uppercase}}"
                class="menu-action-icon svg-icon-red" align='center'>
      </svg-icon>
      <div *ngIf="_allowSync && activeTask?.taskActionStage === ActionStageEnum.Waiting && properties?.length > 0">
        <input type="checkbox" [(ngModel)]="isProjectSelected"
               (click)="selectAllProperties()" />
      </div>
    </div>
    <div class="portfolio-properties">
      <div class="properties-content">
        <kendo-grid [data]="properties" #raciParticipantsGrid (cellClick)="onRowSelection($event)" class="kendo-white-grid approval-grid"
                    [selectable]="selectableSettings" *ngIf="!groupBy">
          <kendo-grid-column *ngIf="_allowSync" title="" [width]="50">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div *ngIf="activeTask?.taskActionStage === ActionStageEnum.Waiting">
                <input type="checkbox" [(ngModel)]="dataItem.isSelected" (click)="onPropertySelect(dataItem)" />
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="propertyName"
                             title="{{'raci.participantsAssignment.propertyName' | translate}}" [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="municipally"
                             title="{{'raci.participantsAssignment.titleMunicipally' | translate}}" [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="address"
                             title="{{'raci.participantsAssignment.titleAddress' | translate}}" [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="argusPropAssetId"
                             title="{{'raci.participantsAssignment.argusPropAssetId' | translate}}" [width]="auto"></kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="dataStatus" [ngClass]=""
                             title="{{'raci.participantsAssignment.dataStatus' | translate}}" [width]="auto">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div (click)="getLastSyncLogs(dataItem)" class="argus-sync-data-status">{{dataItem.dataStatus}}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [headerClass]="'participants-grid'" field="lastDataSync"
                             title="{{'raci.participantsAssignment.lastDataSync' | translate}}" [width]="auto">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{dataItem.lastDataSync | date: 'dd/MM/YYYY HH:mm'}}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
        <div *ngIf="groupBy">
          <div class="spacing-bottom-5" *ngFor="let item of groupData">
            <kendo-grid [data]="item.approvals"
                        class="kendo-white-grid group-header"
                        (cellClick)="onRowSelection($event)"
                        [hideHeader]="true">

              <kendo-grid-column [headerClass]="'participants-grid group-name'"
                                 field="project"
                                 title="project"
                                 class="fill-line"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="group-name-wrapper">
                    <h4 class="properties-name">{{item.group}}</h4>
                    <div class="dashed-bottom"></div>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid fill-line'"
                                 field="line"
                                 title="line"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="dashed-bottom"></div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid fill-line'"
                                 field="line"
                                 title="line"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="dashed-bottom"></div>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
            <kendo-grid [data]="item.tasks"
                        #raciParticipantsGrid
                        class="kendo-white-grid approval-grid group-approval-grid grid-spacing-left-3"
                        [selectable]="selectableSettings"
                        (cellClick)="onRowSelection($event)"
                        kendoGridSelectBy="oid"
                        [(selectedKeys)]="item.selectedRows"
                        (selectedKeysChange)="onSelectionChange(item.group)">

              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="propertyName"
                                 title="{{'raci.participantsAssignment.propertyName' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="municipally"
                                 title="{{'raci.participantsAssignment.titleMunicipally' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="address"
                                 title="{{'raci.participantsAssignment.titleAddress' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="argusPropAssetId"
                                 title="{{'raci.participantsAssignment.argusPropAssetId' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="dataStatus"
                                 title="{{'raci.participantsAssignment.dataStatus' | translate}}"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div>{{dataItem.dataStatus}}</div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="lastDataSync"
                                 title="{{'raci.participantsAssignment.lastDataSync' | translate}}"
                                 [width]="auto">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.lastDataSync | date: 'dd/MM/YYYY HH:mm'}}
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
          <div class="center-text font-bold" *ngIf="groupData.length == 0">
            {{'raci.argusSyncInfo.noRecords' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="non-argus-section">
    <p class="properties-argus-title">{{'raci.participantsAssignment.propertiesArgusTittle' | translate}}</p>
    <div class="properties-table-border-red">
      <table class="other-properties" aria-hidden="true">
        <tr class="properties-table-header">
          <th class="properties-column-title">{{'raci.participantsAssignment.argusPropertyName' | translate}}</th>
          <th class="properties-column-title">
            {{'raci.participantsAssignment.argusPropertyMunicipality' | translate}}
          </th>
          <th class="properties-column-title">{{'raci.participantsAssignment.argusPropertyAddress' | translate}}</th>
        </tr>
        <tbody>
          <tr class="properties-table-content" *ngFor="let prop of nonArgusProperties">
            <td title="{{prop.propertyName}}" class="properties-content-title">{{prop.propertyName}}</td>
            <td title="{{prop.municipally}}" class="properties-content-title">{{prop.municipally}}</td>
            <td title="{{prop.address}}" class="properties-content-title">{{prop.address}}</td>
          </tr>
        </tbody>
        <tr>
          <td class="no-properties-title" *ngIf="nonArgusProperties.length == 0">{{'raci.participantsAssignment.noPropertiesTitle' | translate}}</td>
        </tr>
      </table>
    </div>
  </section>
</div>
